import { FunctionFactory } from "survey-core";

export const registerSpeakerPermissionsExpression = () => {
  //eslint-disable @typescript-eslint/no-explicit-any
  const getSpeakerPermissions = function (this: any, params: any) {
    //this.row property available in cells of dropdown and dynamic matrices questions
    console.log("speakerDetails", params);
    // const question = this.row
    //   ? this.row.getQuestionByColumnName(params[0])
    //   : null;

    // if (!question) return "";

    // const selItem = question.selectedItem as any;
    // return selItem?.jsonObj?.profile
    //   ? defaultEmailFromProfile(selItem?.jsonObj?.profile as ProfileLiteView)
    //   : "";
  };

  FunctionFactory.Instance.register(
    "get_speaker_permissions",
    getSpeakerPermissions,
  );
};
